module.exports = __webpack_public_path__ + "img/under-maintenance.10c5c87e.jpg";